import { Info, AlertTriangle } from "lucide-react";

// Reusable disclaimer. `variant` = 'inline' | 'box'
export default function Disclaimer({ text, variant = "box", lastUpdated, year, source }) {
  const message = text ||
    "This calculator provides estimates for educational purposes only and is not financial, tax, or investment advice. Verify figures with a qualified professional before making decisions.";

  if (variant === "inline") {
    return (
      <p data-testid="disclaimer-inline" className="flex items-start gap-2 text-xs text-muted-foreground">
        <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" /> <span>{message}</span>
      </p>
    );
  }

  return (
    <div data-testid="disclaimer-box" className="rounded-lg border border-amber-200 bg-amber-50 p-4">
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-500" />
        <div className="space-y-1 text-sm text-amber-900">
          <p>{message}</p>
          {(year || source || lastUpdated) && (
            <p className="text-xs text-amber-700">
              {year && <>Data year: <strong>{year}</strong>. </>}
              {source && <>Source: {source}. </>}
              {lastUpdated && <>Last updated: {lastUpdated}. </>}
              <em>Verify current-year figures before launch.</em>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
